import React, { useRef } from 'react';
import { Col, Card, Row } from 'tea-component';
import { useHover } from 'ahooks';
import { Bubble } from '@home/components/TeaComponents';
import SimilarCard from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/SimilarCard';
import './index.scss';
import Loading from '@/pages/intelligence/components/Loading';
import { useIntl } from 'umi';
import useGameComparison from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/hooks/useGameComparison';
import GameComparisonIcon from '@intelligence/components/GameComparisonIcon';

interface gameItem {
  // 游戏封面
  cover: string;
  // 游戏名称
  name: string;
  // 图片
  image: string;
  // 时间
  time: string;
  // 发行者
  publisher: string;
  // 唯一id
  app_id: string;
  // 发行国家
  country: string;
}

interface propInfo {
  // 是否上线
  isRelease: boolean;
  // 游戏列表
  similarGames: gameItem[];
  // 游戏类型
  gameType?: string;
  // 目前的tab模块名称 overview、stats、storerank
  activeId: string,
  // 目前的游戏类型名称 mobileGames、pcGames、consoleGames
  moduleName: string,
  entityType: string,
  setDetailIndex: any;
  dLoading: any;
  // Current game ID for VS comparison
  gameId?: string;
}

export default function SimilarGames(props: propInfo) {
  const {
    isRelease,
    similarGames = [],
    activeId,
    moduleName,
    setDetailIndex,
    dLoading,
    entityType,
    gameId,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  // Game Comparison hook - handles VS button click
  // Note: entityType is always 'mobile' for this component (SimilarGames is only used in Mobile Overview)
  const { handleVSClick } = useGameComparison({
    entityType,
    gameId: gameId || '',
  });

  const ref = useRef(null);
  const isHovering = useHover(ref);
  
  const emptyTipsLocaleKey = isRelease ? 'dbi_detail_similar_games_nodata_tips' : 'dbi_detail_game_not_launch_tips';

  // Show VS button only when there are similar games and current game ID
  const showVSButton = gameId && similarGames?.length > 0;

  return (
    <Card ref={ref}>
      <Card.Body
        title={
          <div className="dbi-similar-games-title">
            <span>{formatMessage({ id: `dbi_similar_games` })}</span>
            {isHovering && showVSButton && !['pc', 'console'].includes(entityType) && (
              <Bubble
                dark
                placement="top"
                className="dbi-similar-games-vs-bubble"
                content={formatMessage({ id: 'dbi_vs_button_tooltip' })}
              >
                <button
                  type="button"
                  className="dbi-similar-games-vs-button"
                  onClick={() => handleVSClick(similarGames)}
                >
                  <span className="dbi-similar-games-vs-button-text">
                    {formatMessage({ id: 'dbi_game_comparison' })}
                  </span>
                  <GameComparisonIcon
                    className="dbi-similar-games-vs-button-icon"
                  />
                </button>
              </Bubble>
            )}
          </div>
        }
      >
        {dLoading ? (
          <>
            <div
              style={{
                height: 200,
                color: '#444',
              }}
            >
              <Loading />
            </div>
          </>
        ) : (
          <Row>
            {
              similarGames?.length > 0 ? (similarGames?.map((item: any, index: number) => {
                return (
                  <Col span={6} key={index}>
                    <SimilarCard
                      gameData={item}
                      activeId={activeId}
                      moduleName={moduleName}
                      setDetailIndex={setDetailIndex}
                      entityType={entityType}
                    />
                  </Col>
                )
              })
              ) : <div style={{height:'144px',lineHeight:'144px',textAlign:'center',width:'100%'}}>{formatMessage({ id: emptyTipsLocaleKey })}</div>
            }
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}
